import { render, staticRenderFns } from "./NewsInfoPage.vue?vue&type=template&id=003a7962&"
import script from "./NewsInfoPage.vue?vue&type=script&lang=js&"
export * from "./NewsInfoPage.vue?vue&type=script&lang=js&"
import style0 from "./NewsInfoPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports